import { FC } from 'react';

import { Button } from '@components/button';
import useToggleLiveChat from '@hooks/usetogglelivechat';
import { useDeviceDetect } from '@hooks/usedevicedetect';

interface ImageGalleryButtonProps {
  onImageGallery?: () => void;
}

const ImageGalleryButton: FC<ImageGalleryButtonProps> = ({
  onImageGallery,
}) => {
  const { hideElement } = useToggleLiveChat();
  const { isMobile, isTablet } = useDeviceDetect();
  const isMobileOrTablet = isMobile || isTablet;

  const handleGalleryOpen = () => {
    if (hideElement && isMobileOrTablet) {
      hideElement();
    }
    if (onImageGallery) {
      onImageGallery();
    }
  };

  return (
    <Button
      onClick={handleGalleryOpen}
      mode="custom"
      size="large"
      data-testid="image-button"
      colour="alternative"
    >
      View Image Gallery
    </Button>
  );
};

export default ImageGalleryButton;
